<template>
  <div v-if="isLoggedIn" class="flex min-h-screen flex-col">
    <div class="flex min-h-screen bg-[linear-gradient(180deg,#f8fafc_0%,#eef3f8_100%)]">
      <AppSidebar :isOpen="isSidebarOpen" @close="isSidebarOpen = false" />

      <div class="flex min-w-0 flex-1 flex-col">
        <AppHeader
          :role="role"
          @toggleSidebar="isSidebarOpen = !isSidebarOpen"
        />

        <div class="w-full max-w-[1680px] flex-1 self-center bg-transparent px-7 pb-9 pt-[22px] max-lg:p-4 max-sm:p-3">
          <router-view />
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <LoginPage />
  </div>
</template>

<script>
import LoginPage from "@/pages/LoginPage";
import { useStore } from "vuex";
import { computed, ref } from "vue";
import AppSidebar from "@/components/AppSidebar.vue";
import AppHeader from "@/components/AppHeader.vue";

export default {
  components: { LoginPage, AppSidebar, AppHeader },
  setup() {
    const store = useStore();
    const isLoggedIn = computed(() => !!store.state.token);
    const role = computed(() => store.state.permission || "");
    const isSidebarOpen = ref(false);

    return {
      isLoggedIn,
      role,
      isSidebarOpen,
    };
  },
};
</script>
